import { onDocumentReady } from '../utils/events';
import { scrollIntoViewWithOffset } from '../utils/helpers';

onDocumentReady(() => {
  document.querySelectorAll('[data-home-brands]').forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-brand-card]'));
    const previews = Array.from(
      section.querySelectorAll('[data-brand-preview]')
    );
    const feature = section.querySelector('.home-brands__feature');
    const compactMedia = window.matchMedia('(max-width: 1023px)');

    if (!cards.length || !previews.length) return;

    const categories = Array.from(section.querySelectorAll('.brand-category'));
    const mobileFeatures = categories.map((category) => {
      if (!category.querySelector('[data-brand-card]')) return null;
      const panel = document.createElement('aside');
      panel.className = 'home-brands__feature brand-feature';
      panel.setAttribute('aria-live', 'polite');
      panel.hidden = true;
      category.appendChild(panel);
      return panel;
    });

    const rotationDelay = 6000;
    const transitionDelay = 350;
    let rotationTimer;
    let transitionTimer;

    const show = (card) => {
      const targetId = card.dataset.brandCard;
      const target = previews.find((preview) => preview.id === targetId);
      if (!target) return;

      const category = card.closest('.brand-category');
      const activeCards = compactMedia.matches
        ? cards.filter((item) => item.closest('.brand-category') === category)
        : cards;
      const activePreviews = compactMedia.matches
        ? previews.filter((preview) => category.contains(preview))
        : previews;

      activeCards.forEach((item) => {
        item.classList.remove('is-active', 'is-leaving');
        item.setAttribute('aria-pressed', 'false');
      });

      void card.offsetWidth;
      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');

      activePreviews.forEach((preview) => {
        const isActive = preview === target;
        preview.hidden = !isActive;
        preview.classList.toggle('is-active', isActive);
      });

      window.clearTimeout(rotationTimer);
      if (compactMedia.matches) return;
      rotationTimer = window.setTimeout(() => {
        const currentIndex = cards.indexOf(card);
        activate(cards[(currentIndex + 1) % cards.length]);
      }, rotationDelay);
    };

    const activate = (card) => {
      if (!card) return;

      window.clearTimeout(rotationTimer);
      window.clearTimeout(transitionTimer);

      if (compactMedia.matches) {
        show(card);
        return;
      }

      const currentCard = cards.find((item) =>
        item.classList.contains('is-active')
      );

      if (!currentCard || currentCard === card) {
        show(card);
        return;
      }

      currentCard.classList.remove('is-leaving');
      void currentCard.offsetWidth;
      currentCard.classList.add('is-leaving');

      transitionTimer = window.setTimeout(() => {
        show(card);
      }, transitionDelay);
    };

    cards.forEach((card) => {
      card.addEventListener('focus', () => activate(card));
      card.addEventListener('click', () => {
        activate(card);

        if (compactMedia.matches && feature) {
          scrollIntoViewWithOffset(
            card
              .closest('.brand-category')
              .querySelector('.home-brands__feature'),
            20
          );
        }
      });
    });

    const updateLayout = () => {
      window.clearTimeout(rotationTimer);
      window.clearTimeout(transitionTimer);
      feature.hidden = compactMedia.matches;
      categories.forEach((category, index) => {
        const mobileFeature = mobileFeatures[index];
        if (!mobileFeature) return;
        mobileFeature.hidden = !compactMedia.matches;
        const categoryCards = cards.filter(
          (card) => card.closest('.brand-category') === category
        );
        categoryCards.forEach((card) => {
          const preview = previews.find(
            (item) => item.id === card.dataset.brandCard
          );
          if (preview) {
            (compactMedia.matches ? mobileFeature : feature).appendChild(
              preview
            );
          }
        });
        if (compactMedia.matches) {
          show(
            categoryCards.find((card) =>
              card.classList.contains('is-active')
            ) || categoryCards[0]
          );
        }
      });
      if (!compactMedia.matches) {
        activate(
          cards.find((card) => card.classList.contains('is-active')) || cards[0]
        );
      }
    };

    // Pause auto-rotation + progress bar while hovering the main preview block.
    if (feature) {
      feature.addEventListener('mouseenter', () => {
        window.clearTimeout(rotationTimer);
        section.classList.add('is-paused');
      });
      feature.addEventListener('mouseleave', () => {
        section.classList.remove('is-paused');
        if (!compactMedia.matches) {
          const active = cards.find((card) =>
            card.classList.contains('is-active')
          );
          if (active) show(active);
        }
      });
    }

    compactMedia.addEventListener('change', updateLayout);
    updateLayout();

    document.addEventListener('visibilitychange', () => {
      window.clearTimeout(rotationTimer);
      window.clearTimeout(transitionTimer);

      if (!document.hidden) {
        activate(cards.find((card) => card.classList.contains('is-active')));
      }
    });
  });
});
